const roles = {
    ALL: 'ALL',
    ADMIN: 'ADMIN',
    INSIDER: 'INSIDER',
    MANAGER: 'MANAGER',
    OWNER: 'OWNER',
};

const rolesMap = {
    10: { key: roles.OWNER, label: 'Владелец', isLocked: true },
    20: { key: roles.ADMIN, label: 'Администратор' },
    30: { key: roles.MANAGER, label: 'Менеджер' },
};

const actions = {
    CREATE_FORMS: 'CREATE_FORMS',
    EDIT_FORM: 'EDIT_FORM',
    DELETE_FORM: 'DELETE_FORM',
    CREATE_APPS: 'CREATE_APPS',
    VIEW_SETTINGS: 'VIEW_SETTINGS',
    EDIT_SETTINGS: 'EDIT_SETTINGS',
    EDIT_TERMINAL: 'EDIT_TERMINAL',
    ADD_USER: 'ADD_USER',
    EDIT_USER: 'EDIT_USER',
    PAYMENT_ACTIONS: 'PAYMENT_ACTIONS',
    PAUSE_RESUME_SUBSCRIPTION: 'PAUSE_RESUME_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    EDIT_SUBSCRIPTION: 'EDIT_SUBSCRIPTION',
    REFUND_PAYMENT: 'REFUND_PAYMENT',
    RETRY_PAYMENT: 'RETRY_PAYMENT',
    CHANGE_PAYMENT_DATE: 'CHANGE_PAYMENT_DATE',
};

const permissions = new Map();
permissions.set(actions.CREATE_FORMS, [roles.OWNER, roles.ADMIN]);
permissions.set(actions.EDIT_FORM, [roles.OWNER, roles.ADMIN]);
permissions.set(actions.DELETE_FORM, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.VIEW_SETTINGS, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.EDIT_SETTINGS, [roles.OWNER, roles.ADMIN]);
permissions.set(actions.ADD_USER, [roles.OWNER]);
permissions.set(actions.EDIT_TERMINAL, [roles.OWNER]);
permissions.set(actions.CREATE_APPS, [roles.INSIDER, roles.OWNER, roles.ADMIN]);
permissions.set(actions.EDIT_USER, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.PAUSE_RESUME_SUBSCRIPTION, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.CANCEL_SUBSCRIPTION, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.EDIT_SUBSCRIPTION, [roles.ADMIN, roles.OWNER]);
permissions.set(actions.REFUND_PAYMENT, [roles.INSIDER, roles.OWNER]);
permissions.set(actions.RETRY_PAYMENT, [roles.INSIDER]);
permissions.set(actions.CHANGE_PAYMENT_DATE, [roles.INSIDER]);

export { roles, rolesMap, actions, permissions };
